<app-list-table-filters-wrapper
  [filterModel]="filterModel"
  [parentRoute]="parentRoute"
  [subtitle]="'Monitor system logs and audit trail' | translate"
  [toggleFilter]="toggleFilter"
  [storageKey]="storageKey"
  [title]="'Logging' | translate"
  [service]="service"
  [getAllMethod]="getAllMethod"
  [getTotalMethod]="getTotalMethod"
  [isLoading]="loading"
  [defaultParams]="defaultParams"
  [filtersForms]="filtersForms"
  (onRowClick)="onRowClick($event)"
  [methodWithParams]="true"
  (applyFilters)="updateFilters($event)"
  (filterModelChange)="onFilterModelChange($event)"
  (clearFilters)="clearFilters()"
  (onFilterSaved)="onFilterSaved($event)"
  [filtersParams]="filtersParams"
  [columns]="[
    {
      field: 'createAt',
      header: 'DateTime' | translate,
      type: 'custom',
      customTemplate: timestampTemplate,
      width: '190px',
    },
    { field: 'userName', header: 'User' | translate, type: 'custom', customTemplate: userTemplate },
    { field: 'subsystem', header: 'Subsystem' | translate, type: 'custom', customTemplate: subsystemTemplate },
    { field: 'actionCount', header: 'ActionCount' | translate },
    { field: 'eventClass', header: 'EventClass' | translate },
    { field: 'infoObject', header: 'InfoObject' | translate, type: 'custom', customTemplate: infoObjectTemplate },
    { field: 'actions', header: '', type: 'custom', customTemplate: actionsTemplate, width: '80px' },
  ]">
  <ng-template
    #timestampTemplate
    let-row>
    <span class="timestamp">{{ row.createAt | date: "dd.MM.yyyy HH:mm:ss" }}</span>
  </ng-template>

  <ng-template
    #userTemplate
    let-row>
    <span>{{ getUserNameById(row.userName) || "—" }}</span>
  </ng-template>

  <ng-template
    #subsystemTemplate
    let-row>
    <span>{{ row.subsystem || "—" }}</span>
  </ng-template>

  <ng-template
    #infoObjectTemplate
    let-row>
    <span>{{ row.infoObject || "—" }}</span>
  </ng-template>

  <ng-template
    #actionsTemplate
    let-row>
    <button
      pButton
      type="button"
      icon="pi pi-ellipsis-v"
      class="p-button-text p-button-sm"
      (click)="onViewDetails(row)"
      pTooltip="{{ 'View details' | translate }}"
      tooltipPosition="top"></button>
  </ng-template>
</app-list-table-filters-wrapper>

<p-dialog [resizable]="false" [draggable]="false"
  [header]="'Log Details' | translate"
  [(visible)]="showLogDetailsModal"
  [modal]="true"
  [style]="{ width: '90vw', maxWidth: '1200px', borderRadius: '16px' }"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  styleClass="log-details-modal">
  <app-data-table
    [data]="selectedLogDetails"
    [columns]="[
      {
        field: 'createdAt',
        header: 'CreateAt' | translate,
        type: 'custom',
        customTemplate: detailTimestampTemplate,
        width: '200px',
      },
      { field: 'message', header: 'Message' | translate, type: 'custom', customTemplate: messageTemplate },
      { field: 'logLevelType', header: 'LogLevel' | translate, type: 'custom', customTemplate: logLevelTemplate },
      { field: 'path', header: 'Path' | translate, width: '250px' },
    ]"
    class="log-details-table"></app-data-table>

  <ng-template
    #messageTemplate
    let-row>
    <span
      class="message-text"
      [class.truncated]="isMessageLong(row.message)">
      {{ getTruncatedMessage(row.message) }}
    </span>
    <button
      *ngIf="isMessageLong(row.message)"
      pButton
      type="button"
      class="p-button-text p-button-sm ellipsis-button"
      (click)="showFullMessage(row.message)"
      pTooltip="{{ 'Show full message' | translate }}"
      tooltipPosition="top">
      ...
    </button>
  </ng-template>

  <ng-template
    #detailTimestampTemplate
    let-row>
    <span class="timestamp">{{ row.createdAt | date: "dd.MM.yyyy HH:mm:ss" }}</span>
  </ng-template>

  <ng-template
    #logLevelTemplate
    let-row>
    <p-tag
      [value]="row.logLevelType | translate"
      [severity]="getLogLevelSeverity(row.logLevelType)"></p-tag>
  </ng-template>
</p-dialog>

<p-dialog [resizable]="false" [draggable]="false"
  [header]="'Полное сообщение' | translate"
  [(visible)]="showFullMessageModal"
  [modal]="true"
  [style]="{ width: '600px', maxWidth: '90vw', borderRadius: '16px' }"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  styleClass="full-message-modal">
  <div class="full-message-content">
    <pre class="formatted-json">{{ formatJsonMessage(fullMessageContent) }}</pre>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      [label]="'Закрыть' | translate"
      class="p-button-text"
      (click)="showFullMessageModal = false"></button>
    <button
      pButton
      type="button"
      [label]="'Копировать' | translate"
      class="copy-button-black"
      icon="pi pi-copy"
      (click)="copyFullMessage()"></button>
  </ng-template>
</p-dialog>
